import React from 'react';
import Modal from "../../../../component/modal/ModalTemplate";
import * as apiUtil from "../../../../util/apiUtil";
import Loading from "../../../../component/loading/Loading";

class GetMessageForRemindModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.handleRemind = this.handleRemind.bind(this);
        this.handleGetMessage = this.handleGetMessage.bind(this);
        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            loading: false,
            selectedUid: null,
            remindList:[]
        }
    }

    componentDidUpdate(prevProps) {
        // ✅ 모달이 새로 열릴 때만 리스트 요청
        if (!prevProps.isOpen && this.props.isOpen) {
            this.fetchUsageList();
        }
    }

    fetchUsageList() {
        this.setLoading(true);

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/list/remind",
            method: apiUtil.requestMethod.POST,
            isFile: false,
            success: (result) => {
                this.setState({ remindList: result || [] });
            },
            error: () => {
                this.setState({ remindList: [] });
            },
        });
    }

    handleSelect = (uid) => {
        this.setState({ selectedUid: uid });
    };


    setLoading(loading) {
        this.setState({ loading: loading });
    }

    handleRemind() {
        const { selectedUid } = this.state;
        const { setValue, handleClose } = this.props;

        if (!selectedUid) {
            alert("선택된 캠페인이 없습니다.");
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/info/" + selectedUid + "/remind",
            method: apiUtil.requestMethod.POST,
            isFile: false,
            success: (result) => {
                result.rcs.map((rcs, index) => {
                    if(rcs.urlLink?.list) {
                        rcs.urlLink.list?.forEach((url, index) => {
                            const placeholder = `[URL분석${index + 1}]`;
                            rcs.msg = rcs.msg.replace(placeholder, url);
                        });
                    }
                });
                if (result.mms.urlLink?.list){
                    result.mms.urlLink?.list.forEach((url, index) => {
                        const placeholder = `[URL분석${index + 1}]`;
                        result.mms.msg = result.mms.msg.replace(placeholder, url);
                    });
                }

                setValue("remindMessage", result);
                handleClose();
            }
        })
    }

    handleGetMessage() {
        const { selectedUid } = this.state;
        const { setValue, handleClose } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/info/" + selectedUid + "/remind",
            method: apiUtil.requestMethod.POST,
            isFile: false,
            success: async (result) => {
                result.rcs.map((rcs, index) => {
                    if(rcs.urlLink?.list) {
                        rcs.urlLink.list?.forEach((url, index) => {
                            const placeholder = `[URL분석${index + 1}]`;
                            rcs.msg = rcs.msg.replace(placeholder, url);
                        });
                    }
                });
                if (result.mms.urlLink?.list){
                    result.mms.urlLink?.list.forEach((url, index) => {
                        const placeholder = `[URL분석${index + 1}]`;
                        result.mms.msg = result.mms.msg.replace(placeholder, url);
                    });
                }

                setValue("remindText", result);
                handleClose();
            }
        });
    }

    render() {
        const { loading, selectedUid, remindList } = this.state;
        const { isOpen, handleClose } = this.props;
        const { handleRemind, handleSelect, handleGetMessage } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle="이전 캠페인 불러오기"
                className="react-full-modal"
            >
                <Loading loading={loading} />
                <div className='modal-body'>
                    <div className="info-content-item shadow">
                        <ol className="fs-6 mb-2 fw-modal fs-4 ps-4 ps-sm-5">
                            <li>발송 일자 기준, 최근 10개 항목을 불러올 수 있습니다.</li>
                            <li>'리마인드' 버튼 클릭 시, 문구/이미지/타겟 조건 수정은 불가능합니다. (일반 타겟팅 리마인드의 경우 영업일 기준 3일 후부터 발송 가능하며, 체류 위치 타겟팅과 스포츠 경기장 타겟팅은 기존과 동일합니다.)</li>
                            <li>
                                '문구 불러오기' 선택 시, 이전에 발송했던 문구를 복사하여 쉽게 수정하실 수 있습니다.
                            </li>
                        </ol>
                    </div>
                    <div className='table-responsive mt-4' style={{maxHeight: '400px', overflowY: 'scroll'}}>
                        <table className="table table-bordered">
                            <thead className='table-light'>
                            <tr>
                                <th>No.</th>
                                <th>메시지 명</th>
                                <th>등록 일시</th>
                                <th>발송 일시</th>
                            </tr>
                            </thead>
                            <tbody>
                            {remindList.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">NO Data</td>
                                </tr>
                            ) : (
                                remindList.map((item, index) => (
                                    <tr key={item.uid}>
                                        <td className='text-center'>
                                            <input
                                                type="radio"
                                                name="usageSelect"
                                                checked={selectedUid === item.uid}
                                                onChange={() => handleSelect(item.uid)}
                                            />
                                        </td>
                                        <td>{item.name}</td>
                                        <td className='text-center'>{item.createdAt}</td>
                                        <td className='text-center'>{item.sendDate}</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md' onClick={handleRemind}>
                        리마인드
                    </button>
                    <button className='ms-2 btn btn-primary btn-md' onClick={handleGetMessage}>
                        문구 불러오기
                    </button>
                </div>
            </Modal>
        )
    }
}

export default GetMessageForRemindModal;
